import React from "react";

import ResponsiveChart from "components/RunPlot/ResponsiveChart";

import { BarChart, Bar, CartesianGrid, Tooltip, XAxis, YAxis, ResponsiveContainer, Label, Cell } from "recharts";

import styles from "./style.module.css";

const CustomToolTip = (props) => {
  const { active, payload, label } = props;
  if (!active || !payload || !payload[0] || !payload[0].payload) {
    return null;
  }

  return payload.length === 1 ? (
    <div className={styles.cTooltip}>
      <div className={styles.tModel}>
        {payload[0].payload.model ? payload[0].payload.model : payload[0].payload.value}
      </div>
      {payload[0].payload.model && (
        <div className={styles.tBody}>
          <div className={styles.tLabel}>{"Model:"}</div>
          <strong>{payload[0].payload.model}</strong>
        </div>
      )}
      {payload[0].payload.field && (
        <div className={styles.tBody}>
          <div className={styles.tLabel}>{"Field: "}</div>
          <strong>{payload[0].payload.field}</strong>
        </div>
      )}
      {payload[0].payload.value && (
        <div className={styles.tBody}>
          <div className={styles.tLabel}>{"Value: "}</div>
          <strong>{payload[0].payload.value}</strong>
        </div>
      )}
      {payload[0].payload.percentage && (
        <div className={styles.tBody}>
          <div className={styles.tLabel}>{"Percentage: "}</div>
          <strong>{payload[0].payload.percentage.toFixed(4) + "%"}</strong>
        </div>
      )}
    </div>
  ) : (
    <div />
  );
};

const CustomLabel = (props) => {
  const { active, payload, label } = props;

  return (
    <text textAnchor="start" className={styles.aLabel}>
      <tspan
        x={
          props.position === "insideTopLeft"
            ? props.value
              ? 250 / props.value.length
              : 20
            : props.viewBox.x + props.viewBox.width / 2 - 33
        }
        y={props.viewBox.y + props.offset}
      >
        {props.value}
      </tspan>
    </text>
  );
};

const RenderLegend = (props) => {
  const { successStrings } = props;

  return (
    <div className={styles.legendHolder}>
      <div className={styles.legendItem}>
        <div className={styles.legendIcon + " " + styles.positive} />
        <div>{successStrings.positive}</div>
      </div>
      <div className={styles.legendItem}>
        <div className={styles.legendIcon + " " + styles.negative} />
        <div>{successStrings.negative}</div>
      </div>
    </div>
  );
};

function toFixed(num, fixed) {
  var re = new RegExp("^-?\\d+(?:.\\d{0," + (fixed || -1) + "})?");
  return num.toString().match(re)[0];
}

class MaxChart extends React.Component {
  handleRemove() {
    const { fieldSelect, valueSelect, fields, ignored, ignoredValue, updateIgnored, updateIgnoredValue } = this.props;

    if (fieldSelect && valueSelect === undefined) {
      const isIgnored = ignored ? ignored[fieldSelect] : false;

      return updateIgnored(fieldSelect, !isIgnored);
    } else if (
      fieldSelect &&
      valueSelect &&
      fields &&
      fields[fieldSelect] &&
      fields[fieldSelect].type === "categorical"
    ) {
      const isIgnored = ignoredValue && ignoredValue[fieldSelect] ? ignoredValue[fieldSelect][valueSelect] : false;

      return updateIgnoredValue(fieldSelect, valueSelect, !isIgnored);
    }

    return Promise.resolve();
  }

  render() {
    const {
      bars,
      handleSelect,
      fields,
      fieldSelect,
      valueSelect,
      ignored,
      ignoredValue,
      selected,
      label,
      isFullChart
    } = this.props;

    const selectedField = fields && fieldSelect ? fields[fieldSelect] : undefined;

    let isIgnored = false;
    if (fieldSelect && valueSelect === undefined) {
      isIgnored = ignored ? ignored[fieldSelect] : false;
    } else if (
      fieldSelect &&
      valueSelect &&
      fields &&
      fields[fieldSelect] &&
      fields[fieldSelect].type === "categorical"
    ) {
      isIgnored = ignoredValue && ignoredValue[fieldSelect] ? ignoredValue[fieldSelect][valueSelect] : false;
    }

    const pColors = ["#512F77", "#5B2F77", "#642F77", "#6E2F77", "#772F77", "#772F6D"];

    const nColors = ["#3E2F77", "#342F77", "#2F3377", "#2F3D77", "#2F4777"];

    let maxChars = 0;

    bars &&
      bars.forEach((p) => {
        const currChars = p.model && p.model.toString().length;
        if (currChars > maxChars) {
          maxChars = currChars;
        }
      });

    if (bars === undefined || bars.length === 0) {
      return <div />;
    }

    return (
      <div className={styles.modelsChart + (isFullChart ? " " + styles.modelsChartFull : "")} id="mChart">
        <ResponsiveContainer>
          <BarChart
            margin={{
              top: 10,
              right: 20,
              bottom: 20,
              left: maxChars * 5
            }}
            layout="vertical"
            data={bars.map((b) => ({ ...b, model: b.model ? b.model.replace(" ", "_") : b.model }))}
            onClick={() => {}}
          >
            <YAxis type="category" dataKey={"model"}></YAxis>
            <XAxis type="number" dataKey={"percentage"} name={"Percentage"} unit={"%"}>
              <Label value={"Percentage"} offset={0} position="bottom" />
            </XAxis>
            <CartesianGrid strokeDasharray="3 3" />
            <Tooltip content={<CustomToolTip />} />
            <Bar dataKey={"percentage"} onClick={(e) => handleSelect(e.modelId)}>
              {bars.map((p, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={
                    p.percentage > 0
                      ? `rgb(125, 105, 215${selected !== undefined && p.modelId !== selected ? ", 0.5" : ""})`
                      : `rgb(213, 107, 39${selected !== undefined && p.modelId !== selected ? ", 0.5" : ""})`
                  }
                  stroke={
                    p.percentage > 0
                      ? `rgb(125, 105, 215${selected !== undefined && p.modelId !== selected ? ", 0.5" : ""})`
                      : `rgb(213, 107, 39${selected !== undefined && p.modelId !== selected ? ", 0.5" : ""})`
                  }
                />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    );
  }
}

export default ResponsiveChart(MaxChart);
